<template>
  <div class="vue-wrapper-full">
    <TheLoader :active="!bruker"/>

    <keep-alive>
      <BrukerCardSidebar v-if="bruker" :bruker="bruker"/>
    </keep-alive>

    <keep-alive>
      <component v-if="bruker" v-bind:is="selectedContentComponent" v-bind="{bruker: bruker}" v-on:switchBrukerView="onSwitchBrukerView"></component>
    </keep-alive>
  </div>
</template>

<script>
import BrukerService from '@/services/BrukerService'
import BrukerCardSidebar from './BrukerCardSidebar'
// import BrukerCardShow from './BrukerCardShow'
import BrukerCardEdit from './BrukerCardEdit'

export default {
  name: 'BrukerCard',
  components: {
    BrukerCardSidebar
  },
  data () {
    return {
      bruker: null,
      selectedContentComponent: BrukerCardEdit
    }
  },
  created: function () {
    this.fetch()
  },
  methods: {
    fetch: function () {
      this.loading = true

      BrukerService.view(this.$route.params.bruker_id)
        .then((response) => {
          this.bruker = response.data
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn bruker')
          this.$router.go(-1)
        })
    },
    onSwitchBrukerView (editMode) {
      if (editMode) {
        this.selectedContentComponent = BrukerCardEdit
      } else {
        // this.selectedContentComponent = BrukerCardShow
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/BrukerCard.vue